module.exports = "/_next/static/images/meneskum-4a64dbf6e40563d9a796dd215cdcb523.jpg";